<template>
  <div>
    <a-input
      v-model:value="inputValue"
      :placeholder="placeholder"
      :maxlength="+maxLength"
      allow-clear
      class="fw"
      @blur="onBlur"
      @change="onChange"
      :addon-after="addonAfter"
      :disabled="disabled"
    />
    <div class="disabled-cl" v-if="disabled"></div>
  </div>
</template>
<script lang="ts">
import { defineComponent, ref, watch, getCurrentInstance, onMounted } from "vue";
import { Form } from "ant-design-vue";
import { onMountedOrActivated } from "@/core/hooks/onMountedOrActivated";
export default defineComponent({
  isGlobal: true,
  name: "NumberInput",
  props: {
    value: {
      type: [Number, String],
      default: "",
    },
    placeholder: {
      type: String,
      default: "请输入",
    },
    maxLength: {
      type: [Number, String],
      default: 12,
    },
    addonAfter: {
      type: String,
      default: "元",
    },
    precision: {
      type: Number,
      default: 2,
    },
    int: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    min: {
      type: Number,
    },
    max: {
      type: Number,
    },
    autoZero: {
      type: Boolean,
      default: true,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:value", "input", "change", "blur"],
  setup(props, { emit }) {
    const formItemContext = Form.useInjectFormItemContext();
    const { proxy } = getCurrentInstance() as any;
    const inputValue = ref<number | string>("");
    const isChange = ref(false);
    const minOrMax = (val) => {
      let max = props.max;
      let min = props.min;
      let res = val;
      if ((min || min === 0) && (max || max === 0)) {
        if (min > max) [max, min] = [min, max];

        if (val >= max) {
          res = max;
        } else if (val <= min) {
          res = min;
        }
      } else if (min || min === 0) {
        res = Math.max(val, min);
      } else if (max || max === 0) {
        res = Math.min(val, max);
      }
      // if (props.int && !props.autoZero) {
      //   res = Number(parseFloat(res as string).toFixed(props.precision));
      // } else {
      //   res = parseFloat(res as string).toFixed(props.precision);
      // }
      return res;
    };

    const format = (val: string | number, preVal: string | number) => {
      const reg = /^\d+(\.\d*)?$/;
      val += "";
      if ((val as string).indexOf("..") >= 0) {
        formatValue(preVal);
      } else {
        if (reg.test(val as string)) {
          if (
            (val as string).endsWith(".") ||
            (val as string).endsWith(".0") ||
            (val as string).endsWith(".00")
          ) {
            formatValue(val);
          } else {
            formatValue(minOrMax(val));
          }
        } else if (val === "") {
          formatValue(val);
        } else {
          formatValue(preVal);
        }
      }
      // console.log("🚀 ~ file: index.vue:123 ~ format ~ isChange.value", isChange.value)
      if (props.isEdit && !isChange.value) {        
        if (props.int && !props.autoZero) {
          inputValue.value = Number(parseFloat(inputValue.value as string).toFixed(props.precision));
        } else {
          inputValue.value = parseFloat(inputValue.value as string).toFixed(props.precision);
        }
      }
      emit("update:value", inputValue.value);
      emit("input", inputValue.value);
      emit("change", inputValue.value);
    };

    const formatValue = (value) => {
      if (
        (inputValue.value + "").charAt(0) === "." ||
        (inputValue.value + "").length === 0 ||
        (value + "").length === 0
      ) {
        // console.log(inputValue.value);
        inputValue.value = "";
      } else {
        // // console.log('value',value)
        inputValue.value = value;
        // if (
        //   ((value + "") as string).endsWith(".") ||
        //   ((value + "") as string).endsWith(".0") ||
        //   ((value + "") as string).endsWith(".00")
        // ) {
        //   inputValue.value = value;
        // } else {
        //   inputValue.value = value;

        // }
      }
    };
    // '.' at the end or only '-' in the input box.
    const onBlur = () => {
      formatValue(inputValue.value);
      if (props.int && !props.autoZero) {
        inputValue.value = Number(parseFloat(inputValue.value as string).toFixed(props.precision));
      } else {
        inputValue.value = parseFloat(inputValue.value as string).toFixed(props.precision);
      }
      emit("blur", inputValue.value);
    };
    const onChange = () => {
      isChange.value = true;
      // console.log("🚀 ~ file: index.vue:169 ~ onChange ~ isChange.value", isChange.value)
    };

    watch(inputValue, (val, preVal) => {
      if (Number(val) != Number(preVal)) {
        format(val, preVal);
      }
      formItemContext.onFieldChange();
    });

    watch(
      () => props.value,
      (n, preN) => {
        // console.log("🚀 ~ file: index.vue:202 ~ setup ~ n,preN", n, preN);
        if (props.autoZero && props.isEdit && !isChange.value) {
          inputValue.value = parseFloat(n as string).toFixed(props.precision);
          formItemContext.onFieldChange();
        } else {
          //@ts-ignore
          inputValue.value = n;
        }
      },
      {
        immediate: true,
      }
    );
    onMountedOrActivated(() => {
      inputValue.value = props.value;
      isChange.value=false;
      formItemContext.onFieldChange();
    });

    return {
      inputValue,
      onBlur,
      onChange,
    };
  },
});
</script>
<style>
/* to prevent the arrow overflow the popup container,
or the height is not enough when content is empty */
.numeric-input .ant-tooltip-inner {
  min-width: 32px;
  min-height: 37px;
}

.numeric-input .numeric-input-title {
  font-size: 14px;
}
</style>
